//
// RankBase.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../../lib";
import "../../../BIRDModel";
import "./Subset";
import "./RankItemType";

var RankBase = createModule("BIRD::RankBase", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        other: 2,
        includeMissing: 2,
        name: 7,
        type: 4,
        includeTies: 2,
        subset: 4,
        n: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default RankBase;
